import React from "react";
import { Link } from "react-router-dom";
import { getIconComponent } from "../../utils/iconHelper";
import "../../styles/sectionPage.css";

/**
 * Presentational component for the Section Banner.
 * @param {Object} props
 * @param {Object} props.section - The section configuration object
 */
const SectionBanner = ({ section }) => {
  if (!section) return null;

  const { title, description, color, icon } = section;
  const IconComponent = getIconComponent(icon);

  // Safely construct dynamic variables for theme styling
  const bannerStyle = {
    "--section-color": color || "#ff6a00",
    "--section-color-glow": color && color.startsWith("#") ? `${color}26` : "rgba(255, 255, 255, 0.15)",
  };

  return (
    <div style={bannerStyle}>
      {/* Breadcrumb Navigation - Option A: Home > Sections > Title */}
      <div className="breadcrumb-container">
        <Link to="/" className="breadcrumb-link">
          Home
        </Link>
        <span className="breadcrumb-separator">&gt;</span>
        <Link to="/#shop-sections" className="breadcrumb-link">
          Sections
        </Link>
        <span className="breadcrumb-separator">&gt;</span>
        <span className="breadcrumb-active">{title}</span>
      </div>

      {/* Dynamic Banner Container */}
      <div className="section-banner">
        <div className="section-banner-content">
          <div className="section-banner-icon-wrapper">
            <IconComponent size={36} strokeWidth={1.5} />
          </div>
          <div className="section-banner-text">
            <h1 className="section-banner-title">{title}</h1>
            <p className="section-banner-description">{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionBanner;
